export * from './IndexFaces';
export * from './DetectFaces';
export * from './FacialRecognitionError';
export * from './ListCollections';
export * from './SaveFace';
export * from './SearchFacesByImage';
export * from './DeleteFaces';
export * from './CreateCollection';
